import * as fromDashboard from '../reducers/dashboardReducers';

export const getDashboard = state =>
  fromDashboard.getDashboardData(state.dashboard);
export const getGraphData = state =>
  fromDashboard.getGraphData(state.dashboard);
